const axios = require('axios');

export default () => ({
    
    success: false,
    error: false,
    submitting: false,

	onSubmit(){

        if(!this.submitting)
        {
            const self = this;

            let csrfTokenName = document.querySelector('meta[name="csrf-token-name"]').content;
            let csrfTokenValue = document.querySelector('meta[name="csrf-token"]').content;

            let formData = new FormData(self.$root);
            formData.set(csrfTokenName, csrfTokenValue);
            
            self.submitting = true;

            axios.post('', formData)
                .then(function (response) {

                    self.$refs.emailInput.value = '';
                    self.success = true;
                    self.submitting = false;

                }).catch(function (error) {

                    self.success = false;
                    self.error = true;
                    self.submitting = false;
                });
                
        }

    }


});